(function () {
  function bind(header) {
    if (!header || header.dataset.menuImagesBound) return;
    header.dataset.menuImagesBound = 'true';
    var pending;
    var completed = false;
    var lastAttempt = 0;
    var events = ['pointermove', 'pointerdown', 'touchstart', 'keydown'];

    function hydrate() {
      header.querySelectorAll('img[data-menu-src]').forEach(function (img) {
        var srcset = img.getAttribute('data-menu-srcset');
        if (srcset) img.setAttribute('srcset', srcset);
        img.setAttribute('src', img.getAttribute('data-menu-src'));
        img.removeAttribute('data-menu-src');
        img.removeAttribute('data-menu-srcset');
      });
    }

    function finish() {
      hydrate();
      completed = true;
      header.removeAttribute('data-menu-images-deferred');
      events.forEach(function (event) {
        window.removeEventListener(event, load);
      });
      header.removeEventListener('focusin', load);
    }

    function load() {
      if (completed || pending) return;
      if (!header.hasAttribute('data-menu-images-deferred')) {
        finish();
        return;
      }
      if (Date.now() - lastAttempt < 2000) return;
      lastAttempt = Date.now();
      var url = new URL(window.location.href);
      url.searchParams.delete('sections');
      url.searchParams.set('section_id', header.dataset.menuSection);
      pending = fetch(url.toString(), { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Menu images unavailable');
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var rendered = doc.querySelector('#customHeader');
          if (!rendered || rendered.hasAttribute('data-menu-images-deferred')) {
            throw new Error('Menu images not rendered');
          }
          var images = new Map();
          rendered.querySelectorAll('[data-menu-image-key]').forEach(function (item) {
            images.set(item.dataset.menuImageKey, item);
          });
          var targets = Array.from(header.querySelectorAll('[data-menu-image-key]'));
          if (targets.some(function (item) { return !images.has(item.dataset.menuImageKey); })) {
            throw new Error('Menu image response incomplete');
          }
          targets.forEach(function (item) {
            var source = images.get(item.dataset.menuImageKey);
            item.replaceChildren.apply(item, Array.from(source.childNodes).map(function (node) {
              return node.cloneNode(true);
            }));
          });
          finish();
        })
        .catch(function () {})
        .finally(function () { pending = null; });
    }

    events.forEach(function (event) {
      window.addEventListener(event, load, { passive: true });
    });
    header.addEventListener('focusin', load);
    if (header.matches(':hover') || header.contains(document.activeElement)) load();
  }

  bind(document.getElementById('customHeader'));
  document.addEventListener('shopify:section:load', function (event) {
    bind(event.target.querySelector('#customHeader'));
  });
})();
